<template>
    <div class="form-group checkboxes">
        <div class="row">
            <div class="col-md-12">
                <label>Musiikkityylit</label>
            </div>
        </div>
        <div class="row flex-options genre__container">
            <div class="check-box-container" v-for="item in sortedItems" :key="item.id">
                <input class="checkbox-inline" type="checkbox" :id="getInputId(item.id)" v-model="internalSelectedGenres" :value="item" @change="onChange">
                <label :for="getInputId(item.id)" class="checkbox-inline">{{ item.name }}</label>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        model: {
            prop: 'selectedGenres',
            event: 'change'
        },
        props: {
            items: {
                type: Array
            },
            name: {
                type: String,
                required: false,
                default: 'genre'
            },
            selectedGenres: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                internalSelectedGenres: this.selectedGenres
            };
        },
        methods: {
            onChange() {
                this.$emit('change', this.internalSelectedGenres);
            },
            getInputId(id) {
                return `${this.name}-${id}`;
            }
        },
        computed: {
            sortedItems() {
                let res = this.items.slice(0).sort((one, other) => {
                    return one.name.length - other.name.length;
                });
                return res;
            }
        }
    };
</script>
